import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  DsCheckboxModule,
  DsFormFieldModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaModule,
  DsLoadingAreaService,
  DsProgressCircleModule,
  DsSelectModule,
  SelectListOption,
} from '@bmw-ds/components';
import { FormsModule } from '@angular/forms';
import { ModelOption } from '../../models/stock-item.model';
import {
  GroupTabDto,
  ModelTabDto,
  UnitSearchModelsRequest,
  UnitSearchModelsResponse,
} from '../../models/unit-search.model';
import { CrossBorderService } from '../../services/crossborder.service';
import { UnitSearchStockRequest } from '../../models/unit-search-stock.model';
import { ProfileDetailBgtRequest, ProfileOption } from '../../models/profile-details-bgt.model';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-filters',
  imports: [
    DsCheckboxModule,
    DsFormFieldModule,
    DsSelectModule,
    DsProgressCircleModule,
    DsLoadingAreaModule,
    FormsModule,
  ],
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
})
export class FiltersComponent implements OnChanges, OnInit {

  @Output() filtersChanged = new EventEmitter<UnitSearchStockRequest>();
  filters = {
    impmodel: '',
    impmodel_group: '',
    impmodel_exopt1: '',
    impmodel_inopt1: '',
    impmodel_inopt2: '',
    impmodel_inopt3: '',
    impmodel_insel1: '',
    impmodel_colour: '',
    impmodel_trim: '',
    orders: '',
  };

  unitSearchStockResponse: UnitSearchModelsResponse | null = null;
  isSearchAllStockChecked: boolean = false;
  modelSelectList: { id: string; label: string }[] = [];
  groupsSelectList: { id: string; label: string }[] = [];
  filteredModelOptions: { id: string; label: string }[] = [];
  locationOptions: { id: string; label: string }[] = [];
  filteredInteriorOptions: { id: string; label: string }[] = [];
  filteredExteriorOptions: { id: string; label: string }[] = [];

  interiorOptions: ModelOption[] = [];
  exteriorOptions: ModelOption[] = [];
  includeOptions: ModelOption[] = [];
  excludeOptions: ModelOption[] = [];
  dealerCode: string = '';
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };
  isModelDisabled: boolean = false;
  isGroupDisabled: boolean = false;
  isOtherSelectsDisabled: boolean = true;

  profileDetailBgtRequest: ProfileDetailBgtRequest = {
    model: '',
    standard: '',
    oasisInd: '',
    allOptions: '',
    fleetInd: '',
  };

  constructor(
    private readonly crossBorderService: CrossBorderService,
    private readonly loadingAreaService: DsLoadingAreaService,
    private readonly authService: AuthService
  ) {}

  onCheckboxChange(value: boolean): void {
    console.log(value);
    this.isSearchAllStockChecked = value;
  }

  ngOnInit() {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    if (this.authService.isAuthenticated()) {
      this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
      this.extracted();
    } else {
      window.location.href = this.authService.getAuthUrl(); // Redirect to the auth URL
    }
  }

  private extracted() {
    const req: UnitSearchModelsRequest = {
      dealer: localStorage.getItem('dealerCode') || '',
    };
    this.crossBorderService.getUnitSearchModels(req).subscribe({
      next: (data: UnitSearchModelsResponse) => {
        this.unitSearchStockResponse = data;
        this.modelSelectList = data.modeltab
          .slice()
          .sort((a, b) => a.z08model.localeCompare(b.z08model))
          .map((model: ModelTabDto) => ({
            id: model.z08model,
            label: model.z08model + ' - ' + model.zmoddesc,
          }));

        this.groupsSelectList = data.grouptab.map((group: GroupTabDto) => ({
          id: group.zgroup,
          label: group.zgroup,
        }));
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      error: (error: unknown) => {
        console.error('Error fetching model options', error);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['externalData'] && changes['externalData'].currentValue) {
      // this.populateDropDowns(changes['externalData'].currentValue);
    }
  }

  private createRequestPayload(): UnitSearchStockRequest {
    return {
      impdlr: localStorage.getItem('dealerCode') || '',
      impmodel: this.filters.impmodel,
      impmodel_colour: this.filters.impmodel_colour,
      impmodel_exopt1: this.filters.impmodel_exopt1,
      impmodel_group: this.filters.impmodel_group,
      impmodel_inopt1: this.filters.impmodel_inopt1,
      impmodel_inopt2: this.filters.impmodel_inopt2,
      impmodel_inopt3: this.filters.impmodel_inopt3,
      impmodel_trim: this.filters.impmodel_trim,
      searchon: '',
      impmodel_extrans: '',
      impmodel_intrans: '',
      impmodel_insel1: '',
    };
  }

  private mapInteriorAndExteriorOptions(): void {
    this.filteredInteriorOptions = this.interiorOptions.map((option) => ({
      id: option.optionCode,
      label: option.optionCode + ' - ' + option.optionDescription,
    }));

    this.filteredExteriorOptions = this.exteriorOptions.map((option) => ({
      id: option.optionCode,
      label: option.optionCode + ' - ' + option.optionDescription,
    }));
    this.filteredModelOptions = this.includeOptions.map((option) => ({
      id: option.optionCode,
      label: option.optionCode + ' - ' + option.optionDescription,
    }));
  }

  onModelChange(event: SelectListOption | SelectListOption[] | null) {
    if (event && !Array.isArray(event)) {
      this.filters.impmodel = (event as SelectListOption).id;

      this.isModelDisabled = false;
      this.isGroupDisabled = true;
      this.isOtherSelectsDisabled = false;
      this.onFiltersChange();
    } else {
      this.filters.impmodel = '';
      this.isModelDisabled = false;
      this.isGroupDisabled = false;
      this.isOtherSelectsDisabled = true;
      this.onFiltersChange();
    }
    this.getProfileDetailBgtRequest();
  }

  onVehicleGroupChange(event: SelectListOption | SelectListOption[] | null) {
    if (event && !Array.isArray(event)) {
      this.filters.impmodel_group = (event as SelectListOption).id;
      this.isModelDisabled = true;
      this.isGroupDisabled = false;
      this.isOtherSelectsDisabled = true;
      this.onFiltersChange();
    } else {
      this.filters.impmodel_group = '';
      this.isModelDisabled = false;
      this.isGroupDisabled = false;
      this.isOtherSelectsDisabled = true;
      this.onFiltersChange();
    }
  }

  onExteriorSelect($event: SelectListOption | SelectListOption[] | null) {
    if ($event && !Array.isArray($event)) {
      this.filters.impmodel_colour = ($event as SelectListOption).id;
    } else {
      this.filters.impmodel_colour = '';
    }
    this.onFiltersChange();
  }

  onInteriorSelect($event: SelectListOption | SelectListOption[] | null) {
    if ($event && !Array.isArray($event)) {
      this.filters.impmodel_trim = ($event as SelectListOption).id;
    } else {
      this.filters.impmodel_trim = '';
    }
    this.onFiltersChange();
  }

  getProfileDetailBgtRequest(): void {
    this.profileDetailBgtRequest.model = this.filters.impmodel;
    this.profileDetailBgtRequest.standard = '';
    this.profileDetailBgtRequest.oasisInd = 'X';
    this.profileDetailBgtRequest.allOptions = 'X';
    this.profileDetailBgtRequest.fleetInd = '';

    this.crossBorderService
      .getProfileDetails(this.profileDetailBgtRequest)
      .subscribe({
        next: (response) => {
          // Extract and map exterior and interior options based on ZOPTIND
          if (response.profile && response.profile.length > 0) {
            this.exteriorOptions = response.profile
              .filter((item: ProfileOption) => item.zoptind === 'L')
              .map((item) => ({
                optionCode: item.zoption,
                optionDescription: item.zodesc,
                optionIndicator: item.zoptind,
                selection: item.zpack,
              }));

            this.interiorOptions = response.profile
              .filter((item: ProfileOption) => item.zoptind === 'P')
              .map((item) => ({
                optionCode: item.zoption,
                optionDescription: item.zodesc,
                optionIndicator: item.zoptind,
                selection: item.zpack,
              }));

            this.includeOptions = response.profile
              .filter((item: ProfileOption) => item.zoptind === 'S')
              .map((item) => ({
                optionCode: item.zoption,
                optionDescription: item.zodesc,
                optionIndicator: item.zoptind,
                selection: item.zpack,
              }));
            this.mapInteriorAndExteriorOptions();
          }

          console.log('Profile Details Response:', response);
          console.log('Profile Details Response:', response);
        },
        error: (error) => {
          console.error('Error fetching profile details:', error);
        },
      });
  }

  onFiltersChange():void
  {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    const requestPayload = this.createRequestPayload();
    this.filtersChanged.emit(requestPayload);
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);

    //check option
  }

  protected onIncludeOptionOneChange($event: SelectListOption | SelectListOption[] | null) {
    // console.log($event);
    if ($event && !Array.isArray($event)) {
      this.filters.impmodel_inopt1 = ($event as SelectListOption).id;
    } else {
      this.filters.impmodel_inopt1 = '';
    }
    this.onFiltersChange();

  }

  protected onIncludeOptionTwoChange($event: SelectListOption | SelectListOption[] | null) {
    // console.log($event);
    if ($event && !Array.isArray($event)) {
      this.filters.impmodel_inopt2 = ($event as SelectListOption).id;
    } else {
      this.filters.impmodel_inopt2 = '';
    }
    this.onFiltersChange();

  }

  protected onIncludeOptionThreeChange($event: SelectListOption | SelectListOption[] | null) {
    // console.log($event);
    if ($event && !Array.isArray($event)) {
      this.filters.impmodel_inopt3 = ($event as SelectListOption).id;
    } else {
      this.filters.impmodel_inopt3 = '';
    }
    this.onFiltersChange();

  }

  protected onExcludeOptionOneChange($event: SelectListOption | SelectListOption[] | null) {
    // console.log($event);
    if ($event && !Array.isArray($event)) {
      this.filters.impmodel_exopt1 = ($event as SelectListOption).id;
    } else {
      this.filters.impmodel_exopt1 = '';
    }
    this.onFiltersChange();

  }
}
